import React from 'react';
import reframe from 'nike-re-framejs';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

class TrackRecentVisit extends React.Component {
    static propTypes = {
        sportEventId: PropTypes.string.isRequired,
        sportId: PropTypes.string.isRequired,
        expiration: PropTypes.string.isRequired,
        participants: PropTypes.any.isRequired
    };

    shouldComponentUpdate() {
        return false;
    }

    componentDidMount() {
        reframe.dispatch([
            'event:recently-visited.add',
            Immutable.fromJS({
                ...this.props,
                id: this.props.sportEventId,
                timestamp: new Date().getTime()
            })
        ]);
    }

    render() {
        return null;
    }
}
export default TrackRecentVisit;
